import * as vp from 'vopay';

import { FunctionComponent } from 'react';

import CredentialsPanel from '../UI/CredentialsPanel';

type AccountCredentialsPanelProps = {
  token: string;
};

type FC = FunctionComponent<AccountCredentialsPanelProps>;

const ActivitySummaryCredentialsPanel: FC = ({ token }: AccountCredentialsPanelProps) => {
  const credentials = getCredentials(token);

  function getCredentials(_token: string): vp.EncodedCredentials {
    const defaults = { AccountID: '', ApiKey: '', ApiSharedSecret: '' };
    if (!token) return defaults;

    // `parseJWT` throws on a token it can't split into JWT segments and base64-decode. Fall back to
    // the empty panel rather than letting a corrupt token take the page down.
    try {
      const json = vp.parseJWT(_token);
      return isEncodedCredentials(json) ? json : defaults;
    } catch (error) {
      console.error(error);

      return defaults;
    }
  }

  function isEncodedCredentials(json: JSON | vp.EncodedCredentials): json is vp.EncodedCredentials {
    const hasAccountID = Object.prototype.hasOwnProperty.call(json, 'AccountID');
    const hasApiKey = Object.prototype.hasOwnProperty.call(json, 'ApiKey');
    const hasApiSharedSecret = Object.prototype.hasOwnProperty.call(json, 'ApiSharedSecret');

    return hasAccountID && hasApiKey && hasApiSharedSecret;
  }

  return <CredentialsPanel credentials={credentials} />;
};

export default ActivitySummaryCredentialsPanel;
